import { createAsyncThunk } from "@reduxjs/toolkit";
import DocumentationApi from "@infrastructure/documentation-api";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import { addSuccessNotification } from "../common/notificationSlice";
export const getAllDocumentationAsync = createAsyncThunk('Documentation/GetAll', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DocumentationApi.getAllDocumentation(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createDocumentationAsync = createAsyncThunk('Documentation/Create', async (createdDocumentation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DocumentationApi.createDocumentation(createdDocumentation);
        dispatch(addSuccessNotification('Documentatie succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentationByIdAsync = createAsyncThunk('Documentation/GetDocumentById', async (documentationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DocumentationApi.getDocumentationById(documentationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const UpdateDocumentationAsync = createAsyncThunk('Documentation/Update', async (updatedDocumentation, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DocumentationApi.updateDocumentation(updatedDocumentation.id, updatedDocumentation);
        dispatch(addSuccessNotification('Documentatie succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteDocumentationByIdAsync = createAsyncThunk(`Documentation/DeleteDocumentation`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DocumentationApi.deleteDocumentationById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentByDocumentationIdAsync = createAsyncThunk('Documentation/UploadDocumentationDocument', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DocumentationApi.addAttachmentByDocumentationId(uploadedFile);
        dispatch(addSuccessNotification("Bestand succesvol geüpload"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByDocumentationIdAsync = createAsyncThunk('Documentation/GetAllDocumentationDocuments', async (documentationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DocumentationApi.getAllAttachmentsByDocumentationId(documentationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteDocumentationDocumentAsync = createAsyncThunk('Documentation/DeleteDocumentationDocument', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await DocumentationApi.deleteDocumentationAttachment(attachmentId);
        dispatch(addSuccessNotification("Bijlage succesvol verwijderd"));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getDocumentationDocumentByIdAsync = createAsyncThunk('Documentation/getDocumentationDocumentById', async (documentationDocument, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await DocumentationApi.getDocumentationDocumentById(documentationDocument);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
